<template>
  <div v-if="drawComponent">
    <div class="row">
      <div class="row" v-if="showForm">
        <div v-if="id">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class='col-sm-12 col-md-12'>
            </div>
          </div>
        </div>
        <div class="col-sm-10" v-else>
          <div id="sale-form-top" class="col-sm-12">
            <panel :title='"New Sale"' :footerShow="true">
              <div class="row">
                <template v-if="_is('superAdmin')">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-6">
                        <label>Select an agency:</label><br/>
                        <select2 name="agency_id" v-bind:list="agencies" class="form-control" :value="agency_id" @input="drpAgencyChanged"></select2>
                      </div>
                      <div class="col-sm-6">
                        <label>Select an agent:</label><br/>
                        <select2 name="created_by" v-bind:list="agents" class="form-control" :value="object.created_by" :options="agentsDropdownOptions" @input="drpAgentChanged"></select2>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="row pl-20">
                  <div class="col-sm-12">
                    <label class="text-bold pr-20">Client: </label>
                    <label class="radio-inline"><input type="radio" class="styled" id="lbn" v-model="newUser" :value="0"/> Select client</label>
                    <label class="radio-inline"><input type="radio" class="styled" id="lby" v-model="newUser" :value="1"/> New client</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class='col-sm-12'>
                  <div class="row">
                    <!-- div class="form-group" :class="{'has-error': errors.has('client_id') }">
                      <select2 name="location" v-bind:list="prospects" validate="'required'" class="form-control" :value="object.client_id" @input="drpClientChanged">
                        <option disabled value="0">Select a prospect...</option>
                      </select2>
                    </div -->
                    <template v-if="newUser">
                      <div class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">First name</label>
                              <input type="text" name="first_name" v-model="userObject.first_name" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Last name</label>
                              <input type="text" name="last_name" v-model="userObject.last_name" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Email</label>
                              <input type="text" name="email" v-model="userObject.email" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Phone</label>
                              <input type="text" name="phone" v-model="userObject.phone" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Date of Birth</label>
                              <date-range-picker :single="true" name="dob" v-model="userObject.dob"></date-range-picker>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Gender</label>
                              <br/>
                              <label class="radio-inline"><input type="radio" name="gender" v-model="userObject.gender" value="male"/> Male</label>
                              <label class="radio-inline"><input type="radio" name="gender" v-model="userObject.gender" value="female"/> Female</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-9">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Address</label>
                              <input type="text" name="address" v-model="userObject.address" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">City</label>
                              <input type="text" name="city" v-model="userObject.city" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Country</label>
                              <input type="text" name="country" v-model="userObject.country" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">State/Province</label>
                              <input type="text" name="state" v-model="userObject.state" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Postal code</label>
                              <input type="text" name="zip" v-model="userObject.zip" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- bank info -->
                      <div class='col-sm-12'>
                        <div class="row">
                          <h3 class="panel-title" style="margin-left: -10px; margin-bottom: 15px;">Bank details</h3>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Bank name</label>
                              <input type="text" name="country" v-model="userObject.bank_name" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">Bank address</label>
                              <input type="text" name="country" v-model="userObject.bank_address" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">IBAN</label>
                              <input type="text" name="state" v-model="userObject.bank_iban" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <div class="form-group" :class="{'has-error': errors.has('location') }">
                              <label class="control-label">BIC</label>
                              <input type="text" name="zip" v-model="userObject.bank_bic" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-sm-6">
                        <select2 name="client_id" :options="prospectsAjaxOptions" validate="'required'" class="form-control" :value="object.client_id" @input="drpClientChanged"></select2>
                      </div>
                    </template>
                  </div>
                  <div class="row">
                    <div class="row">
                      <div class="col-sm-12" v-if="currentProspect">
                        <prospect-view ref="prospectView" :entity="currentProspect" layout="standard" :fullWidth="true"></prospect-view>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footerElements">
                <div class="pull-right">
                  <router-link tag="button" :to="{name: 'sale'}" class="btn btn-link legitRipple">Cancel</router-link>
                  <button type="submit" @click.prevent="saveData()" :disabled="errors.any()" class="btn btn-primary legitRipple">Save changes</button>
                </div>
              </div>
            </panel>
          </div>
          <div class="col-sm-12" id="sale-form-apartments-list">
            <!-- already added apartments -->
            <panel :title='"Apartments"' v-if="!id">
              <div slot="headingElements">
                <a v-show="!id"
                   class="btn"
                   :disabled="!canBeChanged()"
                   v-bind:class='{"btn-success": canBeChanged(), "btn-warning btn-disabled": !canBeChanged()}'
                   @click.prevent='addApartmentClick'>
                  <i class="icon-add"></i> <span class="text-semibold">Add apartment</span>
                </a>
              </div>
              <apartment-list
                :items="object.apartments"
                :columns="{editableStatus: false, status: true, actions: true, deleteItem: true, updateItem: false}"
                :forceShowFloatingPrices="true"
                @itemDelete="deleteApartment"
              >
              </apartment-list>
            </panel>
          </div>

        </div>
      </div>

      <!-- aparment add form/modal -->
      <modal id="apartmentAddForm" :size="'lg'" v-if="addApartmentMode">
        <div slot="header">
          <button type="button" class="close" @click.prevent="addApartmentClose()">×</button>
          <h5 class="modal-title">Add apartment</h5>
        </div>
        <div slot="body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('project_id') }">
                <select2 :list="projectsList" v-model="addApartmentForm.project_id" class="form-control"></select2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <apartment-list v-if="currentProject && currentProject.id"
                              :items="currentProject.apartments.filter(a => object.apartments.indexOf(a) === -1 )"
                              :columns="{editableStatus: false, status: true}"
                              @viewApartmentClick="selectApartmentClick"
                              @toggleSelect="selectApartmentClick"
              >
              </apartment-list>
            </div>
          </div>
        </div>
        <div slot="footer">
          <button type="submit" @click.prevent="addApartmentClose()" :disabled="errors.any()" class="btn btn-primary legitRipple">Ok</button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import ProjectService from '@/services/project.service'
import UserService from '@/services/user.service'
import ProspectService from '@/services/prospect.service'
import SaleService from '@/services/sale.service'
import ApartmentService from '@/services/apartment.service'
import AgencyService from '@/services/agency.service'

import Panel from '@/components/_partial/_atomic/panel'
import Select2 from '@/components/_partial/_atomic/Select2'
import Modal from '@/components/Modal'
import ApartmentList from '../apartment/_partial/List'

import DateRangePicker from '@/components/_partial/_atomic/DateRangePicker'
import ProspectView from '@/components/prospects/View'

export default {
  name: 'SaleForm',
  components: {
    ProspectView,
    DateRangePicker,
    ApartmentList,
    Panel,
    Modal,
    Select2
  },

  props: ['entity', 'oid', 'apartments'],
  data () {
    return {
      id: null,
      object: {},
      userObject: {},
      userId: 0,
      idFilter: [],
      newUser: 0,
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: SaleService,
      services: {
        project: ProjectService,
        user: UserService,
        prospect: ProspectService,
        apartment: ApartmentService,
        agency: AgencyService
      },
      statuses: [],
      systemStatuses: [],
      apartmentStatuses: [],
      apartmentAvailableStatuses: [],
      groupStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        apartmentStatusMap: {},
        resetAfterMount: false
      },
      /** **/
      currentProspect: false,
      currentApartment: { data: {} },
      /** **/
      editMode: false,
      /** **/
      addApartmentMode: false,
      viewApartmentMode: false,
      apartmentEditMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true,
      /** **/
      agency_id: 0,
      prospects: [{
        id: '',
        text: ''
      }],
      projects: [{
        id: '',
        text: ''
      }],
      agencies: [{
        id: '',
        text: ''
      }],
      agents: [{
        id: '',
        text: ''
      }],
      addApartmentForm: {
        project_id: null
      },
      agentsDropdownOptions: {}
    }
  },

  computed: {
    currentProject () {
      let projects = this.projects.filter(item => {
        return this.addApartmentForm.project_id && parseInt(item.id) === parseInt(this.addApartmentForm.project_id)
      })

      return projects.pop()
    },
    projectsList () {
      return this.projects
    },

    prospectsAjaxOptions () {
      let $vm = this
      return {
        debug: true,
        ajax: {
          url: this.services['prospect'].endpoints().list,
          data: function (params) {
            var query = {
              q: params.term
            }
            return query
          },
          delay: 100,
          processResults: function (data) {
            let res = []
            $vm.prospects = [{
              'id': '',
              'text': ''
            }]
            for (let i in data) {
              if (typeof data[i] !== 'object') {
                continue
              }
              res.push({
                id: data[i].id,
                text: $vm.$formatter.formatUser(data[i])
              })
              console.log(data[i])
              let item = Object.assign({
                text: data[i].profile.first_name + ' ' + data[i].profile.last_name + ' (' + data[i].email + ')'
              }, data[i])
              $vm.prospects.push(item)
            }
            return { results: res }
          }
        }
      }
    }
  },

  beforeMount () {
    this.agentsDropdownOptions = {
      templateResult: function (state) {
        console.log(state)
        if (state.role === 'agencyUnlicencedAgent') {
          return $('<span class="text-danger">' + state.text + ' (unlicensed)</span>')
        }
        if (state.userAgencies && state.userAgencies[0].role === 'agencyUnlicensedAgent') {
          return $('<span class="text-danger">' + state.text + ' (unlicensed)</span>')
        }
        return state.text
      }
    }
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.apartmentStatusMap = {
      'label-danger': 3,
      'bg-orange-300': 2,
      'label-success': 1
    }
    this.apartmentStatuses = [
      '',
      'Available', // 1
      'Reserved', // 2
      'Sold' // 3
    ]
    for (let i = 1; i < this.apartmentStatuses.length; i++) {
      this.apartmentAvailableStatuses.push(this.apartmentStatuses[i])
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['project'] ? Vue.config.statusGroups['project'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    this.reset(true)
    this.refresh()
    this.fetchProjects()
    this.fetchProspects()
    if (this._is('superAdmin')) {
      this.fetchAgencies()
    } else {
      this.reassignAgencyId()
    }
    this.mode.resetAfterMount = false
  },

  methods: {
    deleteApartment (e) {
      this.object.apartments = this.object.apartments.filter((el) => { return !(parseInt(el.id) === parseInt(e)) })
      // this.object.apartments =
    },

    reassignAgencyId () {
      if (this._is('agencyAgent') || this._is('agencyAdmin')) {
        let agencies = this.$store.getters.accountAgencies
        console.log(this.$store.getters)
        if (!Array.isArray(agencies)) {
          agencies = JSON.parse(agencies)
        }
        if (Array.isArray(agencies)) {
          this.agency_id = agencies[0].agency_id
        }
        this.created_by = this.$store.getters.userId
      }
    },

    getProspect () {
      if (this.object.client_id) {
        let result = this.prospects.filter(p => p.id === this.object.client_id)
        if (Array.isArray(result)) {
          this.currentProspect = result[0]
          return
        }
      }
      this.currentProspect = false
    },

    drpAgencyChanged (val) {
      if (this.hasOwnProperty('agency_id')) {
        this.agency_id = val
        this.fetchAgents(val)
      }
    },

    drpAgentChanged (val) {
      if (this.object.hasOwnProperty('created_by')) {
        this.object.created_by = val
      }
    },

    drpClientChanged (val) {
      this.userId = parseInt(val)
      console.log(this.userId)
      this.object.client_id = false
      this.getProspect()
      console.log(this.object.client_id)
      if (this.object.hasOwnProperty('client_id')) {
        this.object.client_id = parseInt(val)
        console.log(this.object.client_id)
        this.getProspect()
      }
      this.reassignAgencyId()
    },

    fetchProjects () {
      this.services['project'].getList({
        expand: 'apartments,apartments.data',
        'per-page': 50
      }, data => {
        this.projects = [{
          'id': '',
          'text': ''
        }]
        data.forEach(project => {
          project.text = project.name
          project.id = '' + project.id
          this.projects.push(project)
        })
      })
    },

    fetchAgencies () {
      this.services['agency'].getListAll({}, data => {
        this.agencies = [{
          'id': '',
          'text': ''
        }]
        data.forEach(agency => {
          agency.text = agency.name
          agency.id = '' + agency.id
          this.agencies.push(agency)
        })
      })
    },

    fetchAgents (agencyId) {
      if (parseInt(agencyId) > 0) {
        this.services['agency'].getAgents(agencyId, { 'expand': 'role' }, data => {
          this.agents = [{
            'id': '',
            'text': ''
          }]
          data.forEach(agent => {
            agent.text = agent.profile.first_name + ' ' + agent.profile.last_name
            agent.id = '' + agent.id
            this.agents.push(agent)
          })
        })
      } else {
        this.agents = [{
          'id': '',
          'text': ''
        }]
      }
    },

    fetchProspects () {
      this.services['prospect'].getList({}, data => {
        this.prospects = [{
          'id': '',
          'text': ''
        }]
        data.forEach(prospect => {
          let item = Object.assign({
            text: prospect.profile.first_name + ' ' + prospect.profile.last_name + ' (' + prospect.email + ')'
          }, prospect)
          this.prospects.push(item)
        })
      })
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'sale.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                this.object[i] = result[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          })
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.fetchProspects()
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'required_at') {
              this.object.period = this.$moment(this.object[i]).format(Vue.config.localizedFormat.date)
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      this.$parent.$emit('hide-secondary-sidebar')
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.id = this.object.id
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.$parent.$emit('show-secondary-sidebar')
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.$parent.$emit('show-secondary-sidebar')
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      if (Array.isArray(this.apartments) && this.apartments.length) {
        this.addApartmentsList(this.apartments)
      }
      this.makeIdFilter()
    },

    saveData () {
      if (this.object.apartments.length) {
        if (this.id) {
          this.service.update(this.id, this.prepareData(this.object), result => {
            if (this.editMode) {
              this.editMode = false
            }
            this.refresh()
          })
        } else {
          if (!this.object.client_id) {
            this.services['user'].create(this.prepareUserData(this.userObject), result => {
              for (let i in result) {
                if (result.hasOwnProperty(i)) {
                  this.userObject[i] = result[i]
                }
              }
              this.object.client_id = this.userObject.id
              this.service.create(this.prepareData(this.object), result => {
                for (let i in result) {
                  if (result.hasOwnProperty(i)) {
                    this.object[i] = result[i]
                  }
                }
                this.$router.push('/sale/details/' + this.object.id)
              })
            })
          } else {
            this.services['user'].update(this.object.client_id, this.prepareUserAgency(), result => {
              for (let i in result) {
                if (result.hasOwnProperty(i)) {
                  this.userObject[i] = result[i]
                }
              }
              this.service.create(this.prepareData(this.object), result => {
                for (let i in result) {
                  if (result.hasOwnProperty(i)) {
                    this.object[i] = result[i]
                  }
                }
                this.$router.push('/sale/details/' + this.object.id)
              })
            })
          }
        }
      } else {
        this.$popup.warning('To create offer you need to add apartments you want to offer to client', 'Warning')
      }
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true
    },

    saveChanges () {
      if (this.hasChanges) {
        /* this.savingChanges = true
                this.object.purchaseOrderProducts.forEach(item => {
                  promises.push(PoProductService.update(this.id, item.id, item))
                })
                Promise.all(promises).then(() => {
                  this.savingChanges = false
                  this.hasChanges = false
                  this.reset()
                }) */
      }
    },

    addApartment () {
      this.$refs.apartmentForm.saveData()
    },

    saveApartment () {
      this.$refs.apartmentViewForm.saveData()
    },

    addApartmentClick () {
      this.addApartmentMode = true
    },

    selectApartmentClick (id) {
      console.log(id)
      let $vm = this
      if (typeof id === 'object') {
        if ($vm.object.apartments.map(e => {
          return e.id
        }).indexOf(id.id) === -1) {
          $vm.object.apartments.push(id)
          // $vm.viewApartmentMode = true
        }
        $vm.showLoader = false
      } else {
        $vm.showLoader = true
        if ($vm.object.apartments.map(e => {
          return e.id
        }).indexOf(id) === -1) {
          this.services['apartment'].item(id, result => {
            $vm.object.apartments.push(result)
            $vm.showLoader = false
            // $vm.viewApartmentMode = true
          }, () => {
            $vm.showLoader = false
            $vm.$popup.error('Can\'t load Apartment #' + $vm.$formatter.formatID(id) + ' details')
          })
        }
      }
    },

    addApartmentsList (idArray) {
      let $vm = this
      idArray.forEach((id) => {
        if ($vm.object.apartments.map(e => {
          return e.id
        }).indexOf(id) === -1) {
          this.services['apartment'].item(id, result => {
            $vm.object.apartments.push(result)
            // $vm.viewApartmentMode = true
          }, () => {
            $vm.$popup.error('Can\'t load Apartment #' + $vm.$formatter.formatID(id) + ' details')
          })
        }
      })
    },

    addApartmentClose () {
      this.addApartmentMode = false
    },

    viewApartmentClose () {
      this.$refs.apartmentViewForm.cancelEditMode()
      this.viewApartmentMode = false
      this.apartmentEditMode = false
      this.currentApartment = { data: {} }
    },

    enterApartmentEditMode () {
      this.apartmentEditMode = true
    },

    doneAddApartment (e) {
      let $vm = this
      if (e.id) {
        this.addApartmentMode = false
        $vm.refresh()
        this.$popup.success('Apartment #' + e.data.code + ' successfully added to sale.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    doneEditApartment (e) {
      let $vm = this
      if (e.id) {
        this.viewApartmentMode = false
        $vm.refresh()
        this.$popup.success('Apartment #' + e.data.code + ' successfully saved.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareUserData (obj) {
      let result = {
        first_name: obj.first_name,
        last_name: obj.last_name,
        email: obj.email,
        agency_id: this.agency_id,
        dob: obj.dob,
        zip: obj.zip,
        address: obj.address,
        country: obj.country,
        phone: obj.phone,
        gender: obj.gender,
        state: obj.state,
        city: obj.city || '',
        bank_name: obj.bank_name,
        bank_address: obj.bank_address,
        bank_iban: obj.bank_iban,
        bank_bic: obj.bank_bic,
        role: 'prospect'
      }
      return result
    },

    prepareUserAgency () {
      let result = {
        agency_id: this.agency_id,
        created_by: this.created_by
      }
      return result
    },

    prepareData (obj) {
      // let result = Object.assign({}, obj)
      // result.is_public = result.is_public ? 1 : 0
      let result = {
        client_id: obj.client_id,
        apartments: obj.apartments.map(item => {
          return item.id
        }),
        created_by: this.created_by || obj.created_by
      }
      return result
    },

    canBeChanged () {
      return true
      // let result = typeof this.object === 'object'
      // result = result && this.object.status === 1
      // return result
    },

    changePublicProject (event) {
      this.object.is_public = event.value
    },

    /** invoice can be **/

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    }

    /** action methods **/
    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
    // eslint-disable-next-line
    $('.sidebar-secondary').remove()
  }
}
</script>

<style>
  @media print {
    header, .nav-new, #sale-form-top, .panel-heading, .btn, .panel-footer {
      display: none !important;
    }
    .panel-body {
      padding: 0;
    }
    table td, table th {
      padding: 2px;
    }
    #sale-form-apartments-list {
      display: block !important;
    }
  }
</style>
